export default "__VITE_ASSET__DBkaNCV1__"